import { DestroyRef, Directive, inject, OnDestroy, OnInit } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { ConfigurationState, CountryInfo, EnumeratedTypesRepositoryService, eOrderType, eOrderTypeGroup, OrderManagerService, OrderRepositoryService, SelectOption } from "reg-hub-common";
import { EnvironmentUrlService } from "../services/environment-url/environment-url.service";
import { EagerFetchRepositoryService } from "../services/eager-fetch-repository/eager-fetch-repository.service";
import { Subject, takeUntil } from "rxjs";

@Directive()
export abstract class BaseInformationComponent implements OnInit, OnDestroy {
  protected destroyRef = inject(DestroyRef);
  protected baseOrderDetails!: FormGroup;
  protected orderTypes: SelectOption[] = [];
  protected userGroups: SelectOption[] = [];
  protected bundles: SelectOption[] = [];
  protected countries!: CountryInfo[];

  protected onDestroy$ = new Subject<void>();

  constructor(
    protected environmentUrl: EnvironmentUrlService,
    protected ordersRepo: OrderRepositoryService,
    protected orderManager: OrderManagerService,
    protected enumeratedTypesRepo: EnumeratedTypesRepositoryService,
    protected router: Router,
    protected configurationState: ConfigurationState,
    protected eagerFetchService: EagerFetchRepositoryService) { }

  ngOnInit(): void {
    this.configurationState.getUserGroupID().then(userGroupID => {
      this.baseOrderDetails.get('userGroupID')?.setValue(userGroupID);
    });

    this.eagerFetchService.userGroupOptions.pipe(
      takeUntil(this.onDestroy$)
    ).subscribe(userGroupOptions => this.userGroups = userGroupOptions);
    this.eagerFetchService.bundleOptions.pipe(
      takeUntil(this.onDestroy$)
    ).subscribe(bundleOptions => this.bundles = bundleOptions);

    this.enumeratedTypesRepo.getOrderTypeCountriesAndJurisdictions([eOrderType.knowYourCustomer]).subscribe(types => {
        this.countries = types.flatMap(t => t.countries);

        if (this.countries.length <= 1) {
            this.baseOrderDetails.get('country')?.disable();
        } else {
            this.baseOrderDetails.get('country')?.enable();
        }
    });
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  protected getOrderTypes(orderTypeGroupIDs: eOrderTypeGroup[], exclude?: eOrderType[]) {
    this.enumeratedTypesRepo.getOrderTypesAsSelectOptions(
        this.environmentUrl.urlAddress,
        orderTypeGroupIDs,
        exclude)
      .subscribe(orderTypes => {
        orderTypes.forEach(orderType => {
          this.configurationState.canDraftOrderType(orderType.value as eOrderType)
            .then(access => {
              if (access) this.orderTypes.push(orderType);
            })
        })
      });
  }

}